import {Injectable} from "@angular/core";
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import { environment } from '../../../environments/environment';

import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class FormacaoAcademicaService {

  private _Url = environment.UrlPrincipal + '/api/formacaoacademica';

  constructor(private http: HttpClient) {}

  list(codigo_pessoa) {
    return this.http.get(this._Url + '?codigo_pessoa=' + codigo_pessoa)
            .catch(this.handleError);
  }

  find(codigo) {
    return this.http.get(this._Url + '/' + codigo)
            .catch(this.handleError);
  }

  private handleError(error: Response) {
    return error.json();
  }

}
